(() => {
  'use strict';
  const config=JSON.parse(document.getElementById('cs-config').textContent);
  config.root=(config.root||'/').replace(/\/?$/,'/');
  config.locale='fr-FR';
  window.CSConfig=config;
  const models=window.CATALOGUE||[];
  const live=JSON.parse(document.getElementById('cs-live-catalogue').textContent);
  const asset=src=>config.assets[src]||src;
  window.CATALOGUE=live.map(item=>{
    const editorial=models.find(p=>p.handle===item.handle)||{};
    const normal=value=>String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    const colors={black:'Noir',white:'Blanc',blue:'Bleu','navy blue':'Bleu marine',navy:'Bleu marine',grey:'Gris',gray:'Gris',red:'Rouge',pink:'Rose',brown:'Marron',green:'Vert',beige:'Beige'};
    const colorValue=value=>colors[normal(value)]||value;
    const options=(item.options||[]).map(o=>({...o,name:/^(size|taille)$/.test(normal(o.name))?'Taille':/^(color|colour|couleur)$/.test(normal(o.name))?'Couleur':o.name,values:o.values.map(v=>typeof v==='object'?v.name:v)}));
    const colorOption=options.find(o=>o.name==='Couleur');
    if(colorOption)colorOption.values=colorOption.values.map(colorValue);
    const values=pattern=>options.find(o=>pattern.test(o.name.toLowerCase()))?.values||[];
    const images=item.images.length?item.images:(editorial.images||[]).map(asset);
    return {...editorial,id:item.id,handle:item.handle,title:item.title,url:item.url,available:item.available,
      price:item.price/100,compareAtPrice:item.compare_at_price/100,category:editorial.category||item.type||'La collection',
      image:item.image||asset(editorial.image)||images[0],images,options,
      colors:values(/couleur|colou?r/),sizes:values(/taille|size/),
      features:editorial.features||[],description:item.description,batteryNote:editorial.batteryNote||'',
      hasOnlyDefaultVariant:item.has_only_default_variant||item.variants.length===1&&/^default title$/i.test(item.variants[0].title),
      variants:item.variants.map(v=>{const variant={...v,price:v.price/100,compareAtPrice:v.compareAtPrice/100,image:v.image||null};if(colorOption)variant['option'+colorOption.position]=colorValue(variant['option'+colorOption.position]);variant.title=/^default title$/i.test(v.title)?'Modèle unique':options.map(o=>variant['option'+o.position]).filter(Boolean).join(' / ');return variant;})};
  });
})();
